import ConsumerBase from './ConsumerBase.js';

/**
 * @module Grid/feature/export/consumer/SingleFetchConsumer
 */

/**
 * This consumer stores all generated pages in a local array and later sends single POST
 * request to the backend.
 *
 * @extends Grid/feature/export/consumer/ConsumerBase
 * @internal
 */
export default class SingleFetchConsumer extends ConsumerBase {
    static configurable = {
        feature : null,

        pages : []
    };

    async consumePage(page) {
        this.pages.push(page);
    }

    async finalize(config) {
        const response = await this.feature.receiveExportContent(this.pages, config);

        this.pages.length = 0;

        await this.feature.processExportContent(response, config);

        return { response };
    }
}
